import { Controller } from "stimulus";
import TomSelect from "tom-select";
import { FloatingMenu } from "utils/floating_menu";

export default class extends Controller {
  static targets = ["planSelect", "intervalSelect", "settings", "targetText", "trigger"];
  static values = { floating: Boolean };

  async connect() {
    // The collapsed settings panel opens in the top layer so it breaks out of a
    // scrolling container or modal instead of adding its own scrollbar.
    if (this.floatingValue && this.hasTriggerTarget) {
      this.floatingMenu = new FloatingMenu({ menu: this.settingsTarget, anchor: this.triggerTarget });
    }

    await this.fetchPlans();
    this.initIntervalSelect();
    this.updateFromForm();

    this.element.addEventListener("change", this.updateFromForm.bind(this));
  }

  disconnect() {
    this.floatingMenu?.disconnect();
  }

  show() {
    this.settingsTarget.classList.remove("hidden");
    this.floatingMenu?.open();
  }

  hide() {
    this.settingsTarget.classList.add("hidden");
    this.floatingMenu?.close();
  }

  updateFromForm() {
    const selectedItem = this.element.querySelector("input[type='radio']:checked");
    const targetingType = selectedItem.value;

    this.setTargetText(targetingType);
    this.setTargetingVisibility(targetingType);
  }

  setTargetText(targetingType) {
    let text = "";

    if (targetingType === "all") {
      text = "All Plans";
    } else if (targetingType === "targeted") {
      const value = this.plansTom.getValue().split(",").filter(v => v.length > 0);
      if (value.length === 0) {
        text = "All Plans";
      } else if (value.length === 1) {
        text = this.plansTom.getItem(value[0]).textContent;
      } else {
        text = `${value.length} Plans`;
      }

      if (this.hasIntervalSelectTarget) {
        const interval = this.intervalTom.getValue();
        if (interval) {
          text += ` (${this.intervalTom.getItem(interval).textContent})`;
        }
      }
    }

    this.targetTextTarget.textContent = text;
  }

  setTargetingVisibility(targetingType) {
    if (targetingType === "all") {
      this.hideTom(this.plansTom);
      this.hideTom(this.intervalTom);
    } else if (targetingType === "targeted") {
      this.showTom(this.plansTom);
      this.showTom(this.intervalTom);
    }
  }

  hideTom(tom) {
    if (!tom) return;

    tom.clear();
    tom.wrapper.classList.add("hidden");
  }

  showTom(tom) {
    if (!tom) return;

    tom.wrapper.classList.remove("hidden");
  }

  async fetchPlans() {
    const response = await fetch("/dashboard/shared/plans.json?all=true");
    const { public_plans, unlisted_plans, archived_plans } = await response.json();
    const config = {
      options: [
        ...public_plans.map(plan => ({ value: plan.id, label: plan.name, subscribers: plan.subscription_count, optgroup: "public" })),
        ...unlisted_plans.map(plan => ({ value: plan.id, label: plan.name, subscribers: plan.subscription_count, optgroup: "unlisted" })),
        ...archived_plans.map(plan => ({ value: plan.id, label: plan.name, subscribers: plan.subscription_count, optgroup: "archived" }))
      ],
      optgroups: [
        { value: "public", label: "Public Plans" },
        { value: "unlisted", label: "Unlisted Plans" },
        { value: "archived", label: "Archived Plans" },
      ],
      optgroupField: "optgroup",
      labelField: "label",
      valueField: "value",
      searchField: "label",
      render: {
        optgroup_header: function (data, escape) {
          return '<div class="p-2 text-gray-400">' + escape(data.label) + '</div>';
        },
        option: function (data, escape) {
          return "<div>" + escape(data.label) + " <span class='text-gray-400'>(" + data.subscribers + " subscribers)</span></div>";
        }
      }
    }

    this.plansTom = new TomSelect(this.planSelectTarget, config);
  }

  initIntervalSelect() {
    if (this.hasIntervalSelectTarget) {
      this.intervalTom = new TomSelect(this.intervalSelectTarget, {});
    }
  }
}